import PaymentManagement from '../../Common/Payment/PaymentManagement';
import { useCreateCommonPayment } from '../../Common/apiEndpoints/commonApiEndpoints';
import { VisitorAuthContext } from '../../../Context/AuthContex/VisitorAuthContext';

const VisitorPayment = () => {
  const { dispatch: VisitorAuthDispatch, visitorUser } = VisitorAuthContext();
  const { mutate, isSuccess, data } = useCreateCommonPayment();
  return (
    <PaymentManagement
      isSuccess={isSuccess}
      navigateUrl={'/visitor/invoice'}
      redirectUrl={`/visitor/view-billing-info/${data?.data?.invoice_id}`}
      onChangeValue={async ({ payable_amount, ...data }) => {
        const formData = new FormData();
        const allValue = {
          ...data,
          user_id: visitorUser?.visitor_id,
          user_type: 'Visitor',
          payment_type: 'offline',
        };
        Object.keys(allValue).forEach((key) => {
          if (typeof allValue[key] === 'object') {
            formData.append(key, allValue[key][0]);
          } else {
            formData.append(key, allValue[key]);
          }
        });
        await mutate(formData);
      }}
    />
  );
};

export default VisitorPayment;
